import React, {Component} from 'react'
import PropTypes from 'prop-types'

function CustomBar(props){
    // hijau, kuning, merah, biru
    const colors = ['#16D02C', '#FFC402', '#FB3C00']
    const {type, value, backgroundColor, inlineText, style} = props

    return(
        <div style={{width: '100%', margin: 0, padding: 0, backgroundColor: 'rgba(216, 216, 216, 0.15)', display: 'flex', flexDirection: 'row', alignItems: 'center', height: 24, ...style}}>
            {
                type == "single" ?
                <div style={{width: value == 0 ? '100%' : `${value}%`, height: '100%', margin: 0, backgroundColor: value == 0 ? 'rgba(216, 216, 216, 0.15)' : backgroundColor, display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                    <h1 style={{fontSize: 12, color: '#fff', margin: 0}}>{inlineText}</h1>
                </div> : type == "multi" ? 
                value.map((item, index) => (
                    <div style={{width: `${item}%`, height: '100%', margin: 0, marginLeft: index != 0 ? 2 : 0, backgroundColor: colors[index], display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'center'}}>
                    {
                        inlineText ? <h1 style={{fontSize: 12, color: '#fff', margin: 0}}>{inlineText[index]}</h1> : null
                    }
                </div>
                )) : null
            }
        </div>
    )
}

const customBarPropTypes = {
    type: PropTypes.oneOf(["single, multi"]).isRequired,
    // if single value: number, if multiple value: array
    value: PropTypes.any.isRequired,
    backgroundColor: PropTypes.string.isRequired,
}

CustomBar.propTypes = customBarPropTypes

export default CustomBar


// WEBPACK FOOTER //
// ./src/views/CustomComponents/CustomBar.jsx